import { Box } from '@chakra-ui/react';

import { useUserTrialDetails } from '@revelio/auth';
import { WithTooltip } from '@revelio/core';
import type { TalentDiscoveryV2RespUser } from '@revelio/data-access';

import { SourceWhaleExportButton } from './source-whale/components/source-whale-export-button';

interface TalentDiscoverySourceWhaleButtonProps {
  disabled?: boolean;
  selectedRows?: Record<string, unknown>[];
}

export const TalentDiscoverySourceWhaleButton = ({
  disabled = false,
  selectedRows = [],
}: TalentDiscoverySourceWhaleButtonProps) => {
  const { isTrialUser } = useUserTrialDetails<boolean>({
    initialRenderValue: false,
  });

  return (
    <WithTooltip
      showCondition={isTrialUser}
      placement="top"
      variant="label"
      padding="10px 15px"
      label="This feature is not available for trial users"
      aria-label="This feature is not available for trial users"
    >
      <Box>
        <SourceWhaleExportButton
          disabled={isTrialUser || disabled}
          selectedUsers={(selectedRows || []).map(
            (r) => r.__metaData as TalentDiscoveryV2RespUser
          )}
        />
      </Box>
    </WithTooltip>
  );
};
